import React from 'react';
const ConnectShopifyStoreVerifyPage = () => <div className={'dashboard-page'}/>

export default ConnectShopifyStoreVerifyPage
